// List of all Available Jobs Selectors
export const getDefaultFilters = ({ availableJobList }) => availableJobList.searchFilter;
export const getListPageTitle = ({ availableJobList }) => availableJobList.searchLabel;
export const getListAlertModal = ({ availableJobList }) => availableJobList.alert;
export const getListConfirmModal = ({ availableJobList }) => availableJobList.confirmModal;

// Table selectors
export const getCurrentPage = ({ availableJobList }) => availableJobList.searchFilter.Pagination.Page;
export const getSortModel = ({ availableJobList }) => availableJobList.resultTable.appliedFilter.Pagination.Sort;
export const getRowsPerPage = ({ availableJobList }) => availableJobList.resultTable.rowsPerPage;
export const isTableLoading = ({ availableJobList }) => availableJobList.resultTable.loading;
export const getTableData = ({ availableJobList }) => availableJobList.resultTable.data;
export const getTotalCount = ({ availableJobList }) => availableJobList.resultTable.totalCount;
export const getTableSelectedRows = ({ availableJobList }) => availableJobList.resultTable.selectedRows;


// Available Jobs Add Form
export const getAddFormData = ({ availableJobList }) => availableJobList.addForm;
export const getAlertModalData = ({ availableJobList }) => availableJobList.alert;
export const getShowLoading = ({ availableJobList }) => availableJobList.loading;
export const getUpdateValues = ({ availableJobList }) => availableJobList.updateValues;
